<template>

    <v-container fluid class="welcome-container container">
        <v-row class="d-flex flex-column">

            <v-col cols='12' class="d-flex flex-column justify-center align-center col-1" >

                <div class=" font-weight-bold text-color text-center welcome-1" :class="isMobile ? 'body-1' : ''" v-html="$t('dash_overview.welcome')"></div>

            </v-col>
            <v-col cols='12' class="d-flex flex-column justify-center align-center">

                <div :class="isMobile ? 'body-1' : ''" class=" welcome-2">{{$t('dash_overview.welcome_2')}}<span class="text-color-2 font-weight-bold welcome-username-show">{{userName}}</span></div>

            </v-col>
            <v-col cols='12' class="d-flex flex-column justify-center align-center">

                <div :class="isMobile ? 'body-1' : ''" class=" text-center welcome-2" v-html="$t('dash_overview.welcome_3')"></div>
                <span :class="isMobile ? 'body-1' : ''" class="text-color welcome-3 link-text text-center" @click="goConfig">{{$t('dash_overview.welcome_4')}}</span>

            </v-col>

        </v-row>
    </v-container>

</template>

<script>
import { ROUTE_DASH_CONFIG } from '../../../router/routes';

export default {

    name: 'WelcomeDashContainer',

    props: ['userName'],

    methods: {
    
        goConfig() {

            this.$router.push(ROUTE_DASH_CONFIG);

        }

    },

}

</script>

<style scoped>

.container {

    height: 50%;
    background-image: url('../../../assets/wave.svg');
    background-repeat: no-repeat;
    background-size: cover;

}

.col-1 {

    margin-top: 6%;

}

.link-text {
   
   cursor: pointer
  
}
.text-color {
   
   color: #3fbdbd
  
}

.text-color-2 {
   
   color: #3fbdbd
  
}

.welcome-1 {
   
   font-size: 60px;
  
}

.welcome-2 {
   
   font-size: 25px;
   color: #666464;
  
}

.welcome-3 {
   
   font-size: 25px;
   color: #3fbdbd;
   
  
}


</style>